export default "__VITE_ASSET__CwMvqNIk__"